import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractDomComponent} from "../../framework/abstract-dom";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-textarea-dom",
    styleUrls: ["./textarea-dom.component.scss"],
    templateUrl: "./textarea-dom.component.html",
    standalone: false
})
export class FUITextareaDomComponent extends FUIAbstractDomComponent {
}
